module.exports = __webpack_public_path__ + "static/media/analysis.47b8ded0.png";